<template>
  <!-- TODO turn header into vue component -->
  <div class="clearfix calendar-top-bar">
    <div class="d-flex bd-highlight" >
      <div class="bd-highlight">
        <el-popover
          width="500"
          placement="bottom"
          v-model="popoverVisible" >
          <!-- <el-switch
            size="small"
            active-text="Agenda view"
            inactive-text="Week view"
            :active-value="false"
            :inactive-value="true"
            style="margin-bottom: 1em"
            @change="onChangeCalendarView('week', $event)">
          </el-switch> -->
          <el-row :gutter="20" >
            <el-col :span="8">
              <div class="calendar-top-bar-heading">Agenda View</div>
              <el-button class="btn-block ml-0" size="mini" @click="onChangeCalendarView('agenda', 1)">
                Show Today
              </el-button>
              <el-button class="btn-block ml-0" size="mini" @click="onChangeCalendarView('agenda', 3)">
                Show next 3 days
              </el-button>
              <el-button class="btn-block ml-0" size="mini" @click="onChangeCalendarView('agenda', 7)">
                Show next 7 days
              </el-button>
              <el-button class="btn-block ml-0" size="mini" @click="onChangeCalendarView('agenda', 14)">
                Show next 14 days
              </el-button>
              <el-button class="btn-block ml-0" size="mini" @click="onChangeCalendarView('agenda', 28)">
                Show next 28 days
              </el-button>
              <el-button class="btn-block ml-0" size="mini" @click="onChangeCalendarView('agenda', 90)">
                Show next 90 days
              </el-button>
              <!--
              <el-button class="btn-block ml-0" size="mini" @click="onChangeCalendarView('agenda', 180)">
                Show next 180 days
              </el-button>
              <el-button class="btn-block ml-0" size="mini" @click="onChangeCalendarView('agenda', 360)">
                Show next 360 days
              </el-button>
              -->
              <el-button class="btn-block ml-0" size="mini" @click="onChangeCalendarView('custom')" type="info" plain>
                Show custom range
              </el-button>
            </el-col>
            <el-col :span="8">
              <div class="calendar-top-bar-heading">List View</div>
              <el-button class="btn-block ml-0" size="mini" style="margin-bottom: 1em" @click="onChangeCalendarView('list', 1)">
                Today
              </el-button>
              <el-button class="btn-block ml-0" size="mini" style="margin-bottom: 1em" @click="onChangeCalendarView('list', 3)">
                Show next 3 days
              </el-button>
              <el-button class="btn-block ml-0" size="mini" style="margin-bottom: 1em" @click="onChangeCalendarView('list', 7)">
                Show next 7 days
              </el-button>
              <el-button class="btn-block ml-0" size="mini" style="margin-bottom: 1em" @click="onChangeCalendarView('list', 14)">
                Show next 14 days
              </el-button>
              <el-button class="btn-block ml-0" size="mini" style="margin-bottom: 1em" @click="onChangeCalendarView('list', 28)">
                Show next 28 days
              </el-button>
              <div class="calendar-top-bar-heading">Week View</div>
              <el-button class="btn-block ml-0" size="mini" @click="onChangeCalendarView('agendaWeek', 7)">
                Show week (Mon - Sun) <!-- TODO: Localize week start -->
              </el-button>
              <el-button class="btn-block ml-0" size="mini" @click="onChangeCalendarView('agendaWeek', 5)">
                Show week (Mon - Fri) <!-- TODO: Localize week start -->
              </el-button>
            </el-col>
            <el-col :span="8">
              <div class="calendar-top-bar-heading">Calendar Zoom</div>
              <el-button class="btn-block ml-0" size="mini" @click="onChangeSlotDuration(5)">
                5 Minute Timeslots
              </el-button>
              <el-button class="btn-block ml-0" size="mini" @click="onChangeSlotDuration(15)">
                15 Minute Timeslots
              </el-button>
              <el-button class="btn-block ml-0" size="mini" @click="onChangeSlotDuration(30)">
                30 Minute Timeslots
              </el-button>
              <el-button class="btn-block ml-0" size="mini" @click="onChangeSlotDuration(60)">
                1 hour Timeslots
              </el-button>
              <div class="calendar-top-bar-heading pt-2">Day View</div>
              <el-button class="btn-block ml-0" size="mini" @click="onChangeCalendarView('agendaDay', 'today')" >
                Today
              </el-button>
              <el-button class="btn-block ml-0" size="mini" @click="onChangeCalendarView('agendaDay', 'tomorrow')" >
                Tomorrow
              </el-button>
            </el-col>
          </el-row>
          <hr class="mt-4 mb-4" />
          <el-row :gutter="20">
            <el-col :span="12">
              <div class="calendar-top-bar-heading">Show in Calendar</div>
              <el-checkbox :value="calendar_source_view_settings.optimizer" @input="calendar_toggle_source_view('optimizer')"> show optimizer events</el-checkbox><br />
              <el-checkbox :value="calendar_source_view_settings.user" @input="calendar_toggle_source_view('user')">show manual events</el-checkbox><br />
              <el-checkbox :value="calendar_source_view_settings.tsc" @input="calendar_toggle_source_view('tsc')">show timeslots</el-checkbox><br />
              (<el-checkbox :value="calendar_source_view_settings._stacking" @input="calendar_toggle_source_view('_stacking')">Stack timeslost when shown on side?</el-checkbox>)
            </el-col>
            <el-col :span="12">
              <div class="calendar-top-bar-heading">Visible Range ({{calendar_view_settings.visible_time.min_time }} - {{ calendar_view_settings.visible_time.max_time }} h)</div>
              <el-slider
                v-model="visible_time_slider"
                range
                show-stops
                :max="24"
                @change="onChangeVisibleTimeRange()">
              </el-slider>
              <!-- TODO: Bug when sliding outside of the popover -->
              <div>Now indicator</div>
              <!-- <el-form-item label="Now indicator"> -->
              <!-- TODO: calendar_view_settings.now_indicator -->
              <el-switch
                size="small"
                :value="!calendar_view_settings.show_now_indicator"
                @change="onChangeNowIndicator"></el-switch>
              <!-- </el-form-item> -->
              {{calendar_view_settings.show_now_indicator ? 'show' : 'hide'}}
            </el-col>
          </el-row>

          <el-button slot="reference" size="small" >
            <!-- <font-awesome-icon icon="wrench" /> -->
            <slot name="title">
              <span style="font-size: 1.25em; font-weight: bold;">{{title_str}}</span> &nbsp; <font-awesome-icon icon="wrench" />
            </slot>
          </el-button>

        </el-popover>
      </div>
      <el-button-group style="padding-left: 5px">
        <el-button
          v-if="nrDaysVisible > 1"
          size="small"
          @click="onCalendarNavigation('prev')" >
          <font-awesome-icon icon="angle-double-left" size="lg" /><b> Page</b>
        </el-button>
        <el-button
          size="small"
          @click="onCalendarNavigation('prevday')" >
          <font-awesome-icon icon="angle-left" size="lg"/><b> Day</b>
        </el-button>
        <el-button
          size="small"
          @click="onCalendarNavigation('nextday')" >
          <b>Day </b> <font-awesome-icon icon="angle-right" size="lg" />
        </el-button>
        <el-button
          v-if="nrDaysVisible > 1"
          size="small"
          @click="onCalendarNavigation('next')" >
          <b>Page </b> <font-awesome-icon icon="angle-double-right" size="lg"/>
        </el-button>
      </el-button-group>
      <!--<div class="flex-grow-1 bd-highlight">
        <slot name="title">
          <span style="font-size: 1.25em; font-weight: bold;">{{title_str}}</span> <font-awesome-icon icon="wrench" />
        </slot>
      </div> -->
    </div>

    <!------------------------- modalCustomViewRange ----------------------- -->
    <el-dialog
      :visible.sync="modalCustomViewRangeVisible"
      title="Custom view range">

      <el-form
        label-width="160px"
        label-position="left"
        size="small"
        @submit.native.prevent>
        <!--
        <el-form-item label="Business hours start">
          TODO: this component can not handle user timezone
          <el-time-select v-model="calendar_config.businessHours.start" :picker-options="all_day_picker_options" />
        </el-form-item>
        <el-form-item label="Business hours end">
          TODO: this component can not handle user timezone
          <el-time-select v-model="calendar_config.businessHours.end" :picker-options="all_day_picker_options" />
        </el-form-item>
        <el-form-item label="Earliest display time">
          TODO: this component can not handle user timezone
          <el-time-select v-model="calendar_config.minTime" :picker-options="all_day_picker_options" />
        </el-form-item>
        <el-form-item label="Latest disply time">
          TODO: this component can not handle user timezone
          <el-time-select v-model="calendar_config.maxTime" :picker-options="all_day_picker_options" />
        </el-form-item>
        <el-form-item label="Default view">
          <el-select v-model="calendar_config.defaultView" placeholder="Select">
            <el-option label="agendaWeek" value="agendaWeek"></el-option>
            <el-option label="agenda" value="agenda"></el-option>
            <el-option label="listWeek" value="listWeek"></el-option>
          </el-select><br>
        </el-form-item>
        <template v-if="calendar_config.defaultView === 'agenda'">
        </template>
        -->
        <el-form-item label="Visible range start">
          <date-selector v-model="custom_range.from_date" />
        </el-form-item>
        <el-form-item label="Visible range end">
          <date-selector v-model="custom_range.to_date" />
        </el-form-item>
      </el-form>

      <span slot="footer">
        <el-button type="primary" @click="onSaveCustomViewRange">OK</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import $ from 'jquery'
import { mapGetters, mapActions } from 'vuex'
import moment from '@/moment-gp.js';
import DateSelector from '@/components/Elements/DateSelector'

export default {
  data: () => ({
    modalCustomViewRangeVisible: false,
    popoverVisible: false,
    custom_range: {
      from_date: null,
      to_date: null
    },
    visible_time_slider: [0, 24],
    title_str: 'Loading...',
    all_day_picker_options: {
      start: '00:00',
      step:  '01:00',
      end:   '24:00'
    },
    showWarningNextWeek: false,
    showWarningPrevWeek: false,
  }),
  created() {
    this.visible_time_slider[0] = this.calendar_view_settings.visible_time.min_time;
    this.visible_time_slider[1] = this.calendar_view_settings.visible_time.max_time;
  },
  mounted() {
    this.calendarElement = $(this.$parent.$refs.calendar.$el);
    // console.log("calendarElement", this.calendarElement);
  },
  computed: {
    ...mapGetters("calendar",[
      "calendar_source_view_settings",
      "calendar_view_settings"
    ]),
    nrDaysVisible() {
      let current_from = this.calendar_view_settings.visible_range.from_date;
      let current_to = this.calendar_view_settings.visible_range.to_date;
      return current_to.diff(current_from, 'day')
    }
  },
  methods: {
    ...mapActions("calendar",[
      "calendar_set_view_range",
      "calendar_command",
      "calendar_set_zoom",
      "calendar_set_view",
      "calendar_set_visible_time",
      "calendar_toggle_source_view",
      "calendar_toggle_now_indicator"
    ]),

    setTitleString(view) {
      const sameMonth = ( view.intervalStart.format('MM') ===
                          view.intervalEnd.format('MM') );
      let titleStr = ''
      if (view.intervalStart.format('MMM DD') === view.intervalEnd.clone().subtract(1, 'minute').format('MMM DD')) {
        titleStr =
          view.intervalStart.format('MMM DD, YYYY');
      } else {
        titleStr =
          view.intervalStart.format('MMM DD') + ' - ' +
          view.intervalEnd.clone().subtract(1, 'minute').format(sameMonth ? 'DD, YYYY' : 'MMM DD, YYYY');
      }
      this.title_str = titleStr;
    },

    onCalendarNavigation(event) {
      /* Possible events: ['next', 'prev', 'today'] */
      console.log("onCalendarNavigation:", event);

      // TODO: Alternative implement calendar_command
      // this.calendar_command({ command })

      let view = this.calendar_view_settings.view;

      if (event === 'next' || event === 'prev' ) {
        if ( view === 'agenda' ) {
          // We have to calculate prev/next manually

          let current_from = this.calendar_view_settings.visible_range.from_date;
          let current_to = this.calendar_view_settings.visible_range.to_date;

          let delta = current_to.diff( current_from, 'days' ) + 0;

          if ( event === 'prev' ) {
            delta = -delta;
          }

          let from = current_from.clone().add(delta, 'days');
          let to = current_to.clone().add(delta, 'days')

          let settings = { start: from, end: to }
          this.calendarElement.fullCalendar('option', 'visibleRange', settings);

        } else /* if ( ['month', 'basicWeek', 'agendaWeek', 'basicDay', 'agendaDay'].includes(view) ) */ {

          this.calendarElement.fullCalendar(event);
        }

      } else if (event === 'nextday') {
          let current_from = this.calendar_view_settings.visible_range.from_date;
          let current_to = this.calendar_view_settings.visible_range.to_date;

          let from = current_from.clone().add(1, 'days');
          let to = current_to.clone().add(1, 'days')

          let settings = { start: from, end: to }
          this.calendarElement.fullCalendar('option', 'visibleRange', settings);

      } else if (event === 'prevday') {
          let current_from = this.calendar_view_settings.visible_range.from_date;
          let current_to = this.calendar_view_settings.visible_range.to_date;

          let from = current_from.clone().subtract(1, 'days');
          let to = current_to.clone().subtract(1, 'days')

          let settings = { start: from, end: to }
          this.calendarElement.fullCalendar('option', 'visibleRange', settings);

      } else if (event === 'today') {

        if ( view === 'agenda' ) {
          let from = moment.currentDate();
          let to = from.clone().add(1, 'days');

          let settings = { start: from, end: to }
          this.calendarElement.fullCalendar('option', 'visibleRange', settings);

        } else {

          this.calendarElement.fullCalendar('today');
        }
      }

      /* Read range from calendar and write to store */
      let calendarView = this.calendarElement.fullCalendar('getView');
      let from = calendarView.intervalStart;
      let to = calendarView.intervalEnd;
      this.calendar_set_view_range({ from, to })

      this.$emit('action', event);

      // console.log("calendarView", calendarView.intervalStart.toISOString());
      // console.log("calendarView", calendarView.intervalEnd.toISOString());
    },

    onChangeCalendarView(view, horizon, reset = false ) {
      console.log("onChangeCalendarView", view, horizon);

      switch ( view ) {
        case 'agenda': /* Custom + visibleRange */ break;
        case 'agendaWeek':
          if ( horizon === 5) {
            throw new Error('NOT IMPLEMENTED')
          }
          break;
        case 'agendaDay':
          if ( horizon === 'today') {
            horizon = 0; // TODO
          }
          if ( horizon === 'tomorrow') {
            horizon = 1; // TODO
          }
          throw new Error('NOT IMPLEMENTED')
        case 'list': break;
        case 'basicWeek':  break; // TODO
        case 'basicDay':  break; // TODO
        case 'custom':
          // == agenda?
          console.log("onOpenCustomSettings");
          this.popoverVisible = false;
          this.modalCustomViewRangeVisible = true;
          return
      }

      this.calendarElement.fullCalendar('changeView', view, {});
      this.calendar_set_view(view)

      if ( view === 'agenda' ) {

        let from = moment.currentDate()
        let to = from.clone().add(horizon, 'days')

        // console.log("from", from.format());
        // console.log("to", to.format());

        let settings = { start: from, end: to }
        this.calendarElement.fullCalendar('option', 'visibleRange', settings);

        this.calendar_set_view_range({ from, to })
      } else {

        /* fullcalendar takes care of calculating start and end date, so we just
           query the current interval start and end and send it to the store */
        let calendarView = this.calendarElement.fullCalendar('getView');

        let from = calendarView.intervalStart;
        let to = calendarView.intervalEnd;

        this.calendar_set_view_range({ from, to })
      }

      /*
      // PROBLEM: Results in infinity loop sometimes
      if ( reset ) {
        this.$nextTick(() => {
          console.log("calendar WORKAROUND",)
          this.calendarElement.fullCalendar('prev'); // WORKAROUND
          this.calendarElement.fullCalendar('next'); // WORKAROUND

          let height = this.calendarElement.fullCalendar('option', 'height')
          this.calendarElement.fullCalendar('option', 'height', height - 1);
        });
      }
      */

      this.popoverVisible = false;
      // calendarElement.fullCalendar('changeView', 'agenda', {});
      // calendarElement.fullCalendar('option', 'visibleRange', visibleRange);
    },

    onChangeVisibleTimeRange() {

      let new_min_time = this.visible_time_slider[0];
      let new_max_time = this.visible_time_slider[1] < 24
        ? this.visible_time_slider[1]
        : 24;

      // TODO: instead of the getter, it would be better to get the date from
      //       fullcalendar directly
      if (new_min_time !== this.calendar_view_settings.visible_time.min_time) {
        this.calendarElement.fullCalendar(
          'option',
          'minTime',
          moment.utc( new_min_time * 3600 * 1000).format('HH:mm:ss')
        );
      }
      if (new_max_time !== this.calendar_view_settings.visible_time.max_time) {
        this.calendarElement.fullCalendar(
          'option',
          'maxTime',
          moment.utc( new_max_time * 3600 * 1000).format('HH:mm:ss')
        );
      }

      this.calendar_set_visible_time({
        min_time: new_min_time,
        max_time: new_max_time
      })

    },

    onChangeSlotDuration(duration) {
      let zoom = 15;
      switch (duration) {
        case 5:  zoom = '00:05:00'; break
        case 15: zoom = '00:15:00'; break
        case 30: zoom = '00:30:00'; break
        case 60: zoom = '00:60:00'; break
      }
      /* Always apply settings directly */
      this.calendarElement.fullCalendar('option','slotDuration', zoom);

      this.calendar_set_zoom( zoom )

      this.popoverVisible = false;
    },

    onChangeNowIndicator(value) {
      this.calendar_toggle_now_indicator();
    },

    onSaveCustomViewRange() {

      let from = this.custom_range.from_date;
      let to = this.custom_range.to_date.add(1, 'day');
      /* date-picker will always return the beginning of the day:
        "2019-01-07T00:00:00-05:00". Therefor we need to add one day,
         because fullcalendar will only show UNTIL this date */
      if ( from > to ) {
          this.$message({
            message: 'From date must be before from date',
            type: 'warning',
            showClose: true
          });
          return;
      }

      let view = 'agenda';
      this.calendarElement.fullCalendar('changeView', view, {});
      this.calendar_set_view(view);

      let settings = { start: from, end: to };
      this.calendarElement.fullCalendar('option', 'visibleRange', settings);
      this.calendar_set_view_range({ from, to });

      this.modalCustomViewRangeVisible = false;
    },

    /* onSaveCustomViewRange() {
      let config = this.calendar_config;
      console.log("onSaveCustomViewRange", config);

      const update_key_list = [ // TODO
        'businessHours',
        'minTime',
        'maxTime',
        'nowIndicator',
        'firstDay',
      ]

      update_key_list.forEach(key => {
        console.log("Setting option", key, '=>', config[key]);
        this.calendarElement.fullCalendar('option', key, config[key]);
      })

      this.calendarElement.fullCalendar('changeView',
        config['defaultView'], {
          start: config.start,
          end: config.end
        }
      );

      this.$emit('save', this.calendar_config)
    }, */
  },
  components: {
    DateSelector
  }
}
</script>

<style>
.calendar-top-bar {
  padding: 0.5em 0.5em 0.75em 0.5em;
  margin-bottom: 0;
  text-align: center;
  background-color: white;
}
.calendar-top-bar-heading {
  font-weight: bold;
  text-align: center;
  margin-bottom: 5px;
}
</style>
